module.exports = __webpack_public_path__ + "static/media/ZNOG_220.1a176ec9.png";